export const types = {
  SEND_ERROR: 'SEND_ERROR',
};

export const actions = {
  sendError: error => ({
    type: types.SEND_ERROR,
    payload: {
      error,
    },
  }),
};

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/error.js